import { z } from "zod";

export const contactFormSchema = z.object({
  fullName: z.string().trim().min(1, "Name is required").max(150),
  email: z.string().trim().email("Enter a valid email address"),
  phone: z
    .string()
    .trim()
    .regex(/^\+?[0-9\s-]{7,20}$/, "Enter a valid phone number")
    .optional(),
  subject: z.string().trim().min(1, "Subject is required").max(200),
  message: z.string().trim().min(1, "Message is required").max(2000),
});

export type ContactFormInput = z.infer<typeof contactFormSchema>;

export const bookMedicationReviewLeadSchema = z.object({
  fullName: z.string().trim().min(1, "Name is required").max(150),
  email: z.string().trim().email("Enter a valid email address"),
  phone: z
    .string()
    .trim()
    .regex(/^\+?[0-9\s-]{7,20}$/, "Enter a valid phone number"),
  preferredLanguage: z.enum(["en", "ar"]).default("ar"),
  notes: z.string().trim().max(1000).optional(),
});

export type BookMedicationReviewLeadInput = z.infer<typeof bookMedicationReviewLeadSchema>;
